import React, {Fragment, useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { obtenerDatosLlaves } from '../../store/actions/caso-general-action'

import Grilla from './grilla'
import {LoadingComponent} from 'recupero-comunes'
import { configuracionFormAction34, obtenerGastosGrilla } from '../../store/actions/provision-gatos-action'


const ProvisionGastos = ({ handleClose, idCaso,idImplicado,idOrganizacionCaso , tipoGestion, ambitoGestion}) => {
    const [loading,setLoading]=useState(false)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const { llaves} = data_recepciona
    const data_gastos = useSelector((state) => state.provisionGastosReducer)
    const { cfg_form34} = data_gastos
   const dispatch=useDispatch()
    
    useEffect(() => {     

         dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
      
      }, [dispatch])
      useEffect(() => {
        if(llaves){  
            setLoading(true)
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 34
        })).toString('base64')
        dispatch(configuracionFormAction34(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({
                "idCaso": llaves && llaves['idCaso'],
                "idImplicado": llaves && llaves['idImplicado']
            })).toString('base64')
            dispatch(obtenerGastosGrilla(query))
        })
        // .then(()=>{
        //     let query = Buffer.from(JSON.stringify({
        //         "idImplicado": llaves && llaves['idImplicado'],
        //         "idCaso": llaves && llaves['idCaso'],
        //         "idModoIngreso1":238006, 
        //         "idModoIngreso2":null, 
        //         "tipoGestion":tipoGestion,//207001
        //         "ambitoGestion":ambitoGestion//232002
        //     })).toString('base64')
        //     dispatch(obtenerDatosGrilla(query))
        // })
        .then(()=>{
            setLoading(false)
        })
        
    }
    }, [dispatch,llaves])
    return (
        <>
        <LoadingComponent show={loading}/>
            
               {cfg_form34 ? <Grilla handleClose={handleClose}/>:null }
        </>
    )
}

export default ProvisionGastos
